import { getRequest } from '../../../services/api';
import type { Profile } from '../../../services/auth';
import type { ApiResponse } from '../../../services/types';

import type { UcvStatus } from './modules/UserCardVerification/types';
import type { LastPaymentsResponse } from './types';

export async function getUcvStatus() {
  const response = await getRequest<{ data: UcvStatus }>('payment/ucv-status');

  return response.data;
}

export async function getUserProfile() {
  const response = await getRequest<ApiResponse<Profile>>('/v2/user/profile');

  return response.data.data;
}

export async function getLastPaymentMethods<F extends keyof LastPaymentsResponse = keyof LastPaymentsResponse>(
  fields = ['card', 'presentableCard', 'skrill'] as F[],
) {
  const response = await getRequest<ApiResponse<Pick<LastPaymentsResponse, F>>>('/v2/payment/last-payment-method', {
    fields,
  });

  return response.data.data;
}

export type HasSuccessfulPurchaseWithMethodPayload = {
  hasSuccessfulPurchase: boolean;
};

export async function getHasSuccessfulPurchaseWithPaymentMethod(paymentMethod: string) {
  const response = await getRequest<ApiResponse<HasSuccessfulPurchaseWithMethodPayload>>(
    `/v2/payment/has-success-with-method/${paymentMethod}`,
  );

  return response.data.data;
}
